import React from 'react';
import {MasterLayout} from 'components/layouts';
import {OrderHistoryContainer} from 'components/users';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';

class OrderHistory extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.OrderHistory;
  }

  render() {
    return (
      <MasterLayout>
        <OrderHistoryContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(OrderHistory);



// WEBPACK FOOTER //
// ./pages/users/OrderHistory.jsx